import React from 'react';
import classes from './SectionWrapper.module.scss';

function SectionWrapper(props) {
  const { mainTitle, secondaryInfo, extraInfo, children } = props;

  return (
    <section className={classes.sectionWrapper}>
      <div className={classes.headWrapper}>
        <span className={classes.mainTitle}>{mainTitle}</span>
        <span className={classes.extraInfo}>{extraInfo}</span>
        <p className={classes.secondaryInfo}>{secondaryInfo}</p>
      </div>
      {children}
    </section>
  );
}

export default SectionWrapper;
